module.exports = __webpack_public_path__ + "static/media/group47@2x.87b67304.png";